import { render, staticRenderFns } from "./CompaniesModal.vue?vue&type=template&id=315f3f4c&scoped=true"
import script from "./CompaniesModal.vue?vue&type=script&lang=js"
export * from "./CompaniesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f3f4c",
  null
  
)

export default component.exports